import { render, staticRenderFns } from "./Lm321.vue?vue&type=template&id=f87faf5a&scoped=true"
import script from "./Lm321.vue?vue&type=script&lang=js"
export * from "./Lm321.vue?vue&type=script&lang=js"
import style0 from "./Lm321.vue?vue&type=style&index=0&id=f87faf5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87faf5a",
  null
  
)

export default component.exports